import { h, render } from 'preact';
import AdLoader from './utils/ad-loader';
import select from './utils/select';
import Ribbon from './components/Ribbon';

const PRIMARY_GUTEN_TAG = 'subject-2018-elections';
const RELATED_CONTENT_URL = `https://www.texastribune.org/api/v1/content/?content_type=story,audio,video,pointer&tag=${PRIMARY_GUTEN_TAG}&tag!=object-tribcast&fields=id,url,readable_pub_date,headline,short_summary,lead_art&limit=4&format=json`;

export default () => {
  render(<Ribbon />, document.querySelector('#ribbon-container'));

  const loader = new AdLoader({
    targetingKey: 'guten',
    targetingValue: PRIMARY_GUTEN_TAG,
  });

  loader.init();

  var oldLocation = window.location.href.split('#')[0];
  var shiftWindow = function() {
    scrollBy(0, -50);
  };

  var jumper = document.getElementById('nav-dropdown');
  jumper.addEventListener('change', function() {
    var newLocation = oldLocation + this.value;
    window.location.replace(newLocation);
  });

  if (location.hash) shiftWindow();
  window.addEventListener('hashchange', shiftWindow);

  const relatedContentList = select('#related-coverage-list');

  fetch(RELATED_CONTENT_URL)
    .then(res => res.json())
    .then(({ results: stories }) => {
      const items = stories.map(story => {
        let relatedLink;
        if (
          story.url ===
          'https://www.texastribune.org/2018/03/02/11-texas-congressional-primary-races-watch/'
        ) {
          relatedLink = '';
        } else {
          relatedLink = `<li class="related-coverage__item" ga-on="click" ga-event-category="Related link" ga-event-action="${
            story.url
          }" ga-event-label="related - GutenTags"><a href="${story.url}">${
            story.headline
          }</a></li>`;
        }
        return relatedLink;
      });

      relatedContentList.innerHTML = items.join('');
    });
};



// WEBPACK FOOTER //
// ./main.js